<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
        <div class="card card-charges pb-3">
          <div class="row">
            <div class="col-8 align-self-center">
              <h2 class="subtitle mb-0">
                {{ getReservationTypeLabel(serviceType) }}
              </h2>
            </div>
            <div class="col-4 align-self-center text-right"></div>
          </div>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left">
                  <span class="title-table">Description</span>
                </th>
                <th
                  align="right"
                  class="text-right"
                  v-if="['all', 'net_price'].includes(display)"
                >
                  <span class="title-table">Net Price</span>
                </th>
                <th
                  align="right"
                  class="text-right"
                  v-if="['all', 'gross_price'].includes(display)"
                >
                  <span class="title-table">Gross Price</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="left">
                  <span class="price">Base Transfer</span>
                </td>

                <td align="right" v-if="['all', 'net_price'].includes(display)">
                  <span
                    class="price"
                    :class="{
                      'old-price':
                        pricing.net_price.amount !==
                        pricing.net_price.last_amount
                    }"
                  >
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.net_price.amount) }}
                    {{ currency.code }}</span
                  >

                  <span
                    class="price"
                    :class="{
                      'new-price':
                        pricing.net_price.amount !==
                        pricing.net_price.last_amount
                    }"
                    v-if="
                      pricing.net_price.amount !== pricing.net_price.last_amount
                    "
                  >
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.net_price.last_amount) }}
                    {{ currency.code }}
                  </span>
                </td>
                <td
                  align="right"
                  v-if="['all', 'gross_price'].includes(display)"
                >
                  <span
                    class="price"
                    :class="{
                      'old-price':
                        pricing.gross_price.amount !==
                        pricing.gross_price.last_amount
                    }"
                  >
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.gross_price.amount) }}
                    {{ currency.code }}</span
                  >
                  <span
                    class="price"
                    :class="{
                      'new-price':
                        pricing.gross_price.amount !==
                        pricing.gross_price.last_amount
                    }"
                    v-if="
                      pricing.gross_price.amount !==
                        pricing.gross_price.last_amount
                    "
                  >
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.gross_price.last_amount) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
        v-if="pricing.extras.length > 0"
      >
        <div class="card card-charges pb-3">
          <div class="row">
            <div class="col-8 align-self-center">
              <h2 class="subtitle mb-0">
                Extra Charges
              </h2>
            </div>
            <div class="col-4 align-self-center text-right">
              <span
                class="button-edit-min"
                @click="editExtraCharges()"
                v-if="
                  ['new', 'edit'].includes(operation) &&
                    (mode === 'edit' || mode === 'new')
                "
                >Edit</span
              >
            </div>
          </div>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left">
                  <span class="title-table">Description</span>
                </th>
                <th
                  align="right"
                  class="text-right"
                  v-if="['all', 'net_price'].includes(display)"
                >
                  <span class="title-table">Net Price</span>
                </th>
                <th
                  align="right"
                  class="text-right"
                  v-if="['all', 'gross_price'].includes(display)"
                >
                  <span class="title-table">Gross Price</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(extra, index) in pricing.extras">
                <td align="left">
                  <span class="price">{{ extra.description }}</span>
                </td>

                <td align="right" v-if="['all', 'net_price'].includes(display)">
                  <span class="price">
                    {{ currency.symbol }}
                    {{ parsePrice(extra.net_price) }}
                    {{ currency.code }}</span
                  >
                </td>
                <td
                  align="right"
                  v-if="['all', 'gross_price'].includes(display)"
                >
                  <span class="price">
                    {{ currency.symbol }} {{ parsePrice(extra.gross_price) }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
              <tr class="footer-table">
                <td align="left">
                  <span class="totals">Total Extras</span>
                </td>
                <td align="right" v-if="['all', 'net_price'].includes(display)">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.totals.extras.net_price) }}
                    {{ currency.code }}
                  </span>
                </td>
                <td
                  align="right"
                  v-if="['all', 'gross_price'].includes(display)"
                >
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.totals.extras.gross_price) }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
        v-if="pricing.discounts.length > 0 && ['all'].includes(display)"
      >
        <div class="card card-charges pb-3">
          <div class="row">
            <div class="col-8 align-self-center">
              <h2 class="subtitle mb-0">
                Discounts
              </h2>
            </div>
            <div class="col-4 align-self-center text-right">
              <span
                class="button-edit-min"
                @click="editDiscounts()"
                v-if="
                  ['new', 'edit'].includes(operation) &&
                    (mode === 'edit' || mode === 'new')
                "
                >Edit</span
              >
            </div>
          </div>

          <table cellspacing="0" cellpadding="1" class="table-prices">
            <thead>
              <tr class="header-table">
                <th align="left" class="text-left">
                  <span class="title-table">Description</span>
                </th>
                <th align="right" class="text-right">
                  <span class="title-table">Percent</span>
                </th>
                <th align="right" class="text-right">
                  <span class="title-table">Total</span>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(discount, index) in pricing.discounts">
                <td align="left">
                  <span class="price">{{ discount.description }}</span>
                </td>

                <td align="right">
                  <span class="price" v-if="discount.type === 'percentage'">
                    {{ discount.percent }}%</span
                  >
                  <span class="price" v-else>-</span>
                </td>
                <td align="right">
                  <span class="price">
                    {{ currency.symbol }} {{ discount.total }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
              <tr class="footer-table">
                <td align="left">
                  <span class="totals">Total Discounts</span>
                </td>
                <td align="right"></td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.totals.discounts) }}
                    {{ currency.code }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
        <div class="card card-charges">
          <h2 class="subtitle mb-0">Summary</h2>

          <table cellspacing="0" cellpadding="1" class="table-prices mt-1">
            <tbody>
              <tr v-if="['all', 'net_price'].includes(display)">
                <td align="left">
                  <span class="totals">
                    Total Net Price
                  </span>
                </td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.totals.net_price) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>

              <tr v-if="['all', 'gross_price'].includes(display)">
                <td align="left">
                  <span class="totals">
                    Total Gross Price
                  </span>
                </td>
                <td align="right">
                  <span class="totals">
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.totals.gross_price) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>

              <tr v-if="['all'].includes(display)">
                <td align="left">
                  <span class="totals">
                    Total Net Profit
                  </span>
                </td>
                <td align="right">
                  <span
                    class="totals"
                    :class="pricing.totals.net_profit < 0 ? 'loss-alert' : ''"
                  >
                    {{ currency.symbol }}
                    {{ parsePrice(pricing.totals.net_profit) }}
                    {{ currency.code }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
        <div class="card box-total">
          <div class="rows-extra">
            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-7 col-sm-7 col-7 align-self-center"
              >
                <span class="subtitle mb-0">TOTAL CHARGES</span>
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-5 col-sm-5 col-5 text-right align-self-center"
              >
                <span
                  v-if="['all', 'gross_price'].includes(display)"
                  class="subtitle mb-0"
                  :class="pricing.totals.gross_price < 0 ? 'loss-alert' : ''"
                >
                  {{ currency.symbol }}
                  {{ parsePrice(pricing.totals.gross_price) }}
                  {{ currency.code }}
                </span>

                <span
                  v-if="['net_price'].includes(display)"
                  class="subtitle mb-0"
                  :class="pricing.totals.net_price < 0 ? 'loss-alert' : ''"
                >
                  {{ currency.symbol }}
                  {{ parsePrice(pricing.totals.net_price) }} {{ currency.code }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "charges",
  props: {
    currency: {
      code: {
        type: String,
        default: "",
        description: "",
        required: true
      },
      symbol: {
        type: String,
        default: "",
        description: "",
        required: true
      }
    },
    pricing: {
      type: Object,
      required: true
    },
    sendPaymentLink: {
      type: Boolean,
      default: false
    },
    display: {
      type: String,
      description: "(all, net_price, gross_price)",
      default: "all"
    },
    collapse: {
      type: Boolean,
      default: true
    },
    operation: {
      type: String,
      description: "(new, edit, none)",
      default: "none"
    },
    mode: {
      type: String,
      description: "(new, edit, view)",
      default: "view"
    },
    serviceType: {
      type: String,
      default: "transfer",
      description: "Type of service (transfer, experience)",
      validator: function(value) {
        return ["transfer", "experience"].includes(value);
      },
      required: false
    }
  },
  data() {
    return {
      collapseExtras: "Expand",
      collapseDiscounts: "Expand"
    };
  },
  methods: {
    parsePrice(price) {
      return Number.parseFloat(price).toFixed(2);
    },
    collapseExpandExtras() {
      if (this.collapseExtras === "Expand") {
        this.collapseExtras = "Collapse";
      } else {
        this.collapseExtras = "Expand";
      }
    },
    collapseExpandDiscounts() {
      if (this.collapseDiscounts === "Expand") {
        this.collapseDiscounts = "Collapse";
      } else {
        this.collapseDiscounts = "Expand";
      }
    },
    getToggles(name, elements = []) {
      return elements
        .map((element, index) => {
          return `${name}-${index + 1}`;
        })
        .join(" ");
    },
    parseType(type) {
      if (type === "absolute") {
        return "Absolute";
      } else {
        return "Percentage";
      }
    },
    editDiscounts() {
      this.$emit("addAdjustments", "discounts");
    },
    editExtraCharges() {
      this.$emit("addAdjustments", "extraCharges");
    },
    getReservationTypeLabel(serviceType) {
      if (serviceType === "transfer") {
        return "Base Transfer";
      } else if (serviceType === "experience") {
        return "Base Experience";
      }
    }
  }
};
</script>
